import './shared.js';
import uid$1 from './uid.js';
import { s as shared$1 } from '../../../../../../_virtual/shared.js';

var shared = shared$1.exports;
var uid = uid$1;
var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

export { sharedKey as default };
